/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Passkey_Failed_To_LoginInputs */

const nl_auth_passkey_failed_to_login = /** @type {(inputs: Auth_Passkey_Failed_To_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inloggen met passkey is niet gelukt. Controleer of deze passkey actief is op dit apparaat.`)
};

/**

* @param {Auth_Passkey_Failed_To_LoginInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const auth_passkey_failed_to_login = /** @type {((inputs?: Auth_Passkey_Failed_To_LoginInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Passkey_Failed_To_LoginInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_auth_passkey_failed_to_login(inputs)
});
export { auth_passkey_failed_to_login as "auth.passkey.failed_to_login" }